import { lazy } from "react";

const LandingPage = lazy(() => import("./pages/LandingPage"));
const WelcomePage = lazy(() => import("./pages/Welcome"));

export const publicRoutes = [
  { path: "/", element: <LandingPage /> },
];

export const authRoutes = [
  { path: "/welcome", element: <WelcomePage /> },
];
